module.exports = __webpack_public_path__ + "static/media/scopus_logo.7e5f506d.png";